export const PHONE_CONFIRM_MODAL_CONFIRMED_ACTION = 'confirmed';
